import React from 'react';
import styled from 'styled-components';
import { Button } from '@zocdoc-frontend-common/components-button';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { MetricsClickable } from '@zocdoc-frontend-common/utils-frontend-metrics';

const buttonName = 'ViewProfileButton';
const BookButton = ({ className, style }) => {
    return (
        <MetricsClickable
            action={`Click LightweightDoctorCard ${buttonName}`}
            element={`DoctorCard${buttonName}`}
        >
            <StyledButton
                className={className}
                data-test="lightweight-doctor-card-book-button"
                fluid
                style={style}
                variation="btn-primary" // eslint-disable-line react/style-prop-object
            >
                View profile
            </StyledButton>
        </MetricsClickable>
    );
};

const StyledButton = styled(Button)`
    height: 32px;
    font-size: 13px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    ${breakpoint.medium} {
        height: 40px;
        font-size: 15px;
    }
`;

export default BookButton;
